import { Nav, NavItem } from "reactstrap";
import { LeftContactAsideProps } from "../../../../Types/ContactType";
import { AddContact } from "./ContactModals/AddContact";
import { CategoryModal } from "./ContactModals/CategoryModal";
import { Href } from "../../../../Constants/Constants";
import { ContactNavData } from "../../../../Data/Applications/Contacts/Contacts";

export const ContactNav:React.FC<LeftContactAsideProps> = ({ activeTab, setActiveTab, changeTab }) => {
  const tabClick = (id: number) => {
    setActiveTab(id);
    changeTab(id);
  };
  return (
    <Nav className="main-menu contact-options custom-scrollbar">
      <NavItem>
        <AddContact />
      </NavItem>
      <NavItem>
        <span className="main-title">{"Views"}</span>
      </NavItem>
      <NavItem>
        <a href={Href} className={activeTab === 1 ? "active" : ""} onClick={() => tabClick(1)}>
          <span className="title">{"Personal"}</span>
        </a>
      </NavItem>
      <NavItem>
        <CategoryModal />
      </NavItem>
      {ContactNavData.map((item) => (
        <NavItem key={item.id}>
          <a href={Href} className={activeTab === item.id ? "active" : ""} onClick={() => tabClick(item.id)}>
            <span className="title">{item.title}</span>
          </a>
        </NavItem>
      ))}
    </Nav>
  );
};
